import { useState, useEffect } from "react";
import InputButton from "../form/elements/InputButton";
import { useRouter, asPath } from "next/router";

function Filter({ children, params }) {
  const [isOpen, setIsOpen] = useState(false);
  const [reset, setReset] = useState(false);
  const router = useRouter();

  useEffect(() => {
    if (!reset) {
      return;
    }
    isOpen ? setIsOpen(false) : setIsOpen(true);
    router.push(window.location.pathname).then(() => {
      router.reload();
    });
  }, [reset]);

  const handlefilter = (e) => {
    e.preventDefault();
    const form = document.getElementById("filter");
    const formData = new FormData(form);

    // Filter params
    let filterParam = "?";
    for (const [key, value] of formData) {
      filterParam += `${key}=${value}&`;
    }

    // Other params
    let otherParams = "";
    if (params) {
      for (const [key, value] of Object.entries(params)) {
        value ? (otherParams += `${key}=${value}&`) : "";
      }
    }
    isOpen ? setIsOpen(false) : setIsOpen(true);

    const new_url = window.location.pathname + filterParam + otherParams;
    router.push(new_url, undefined, { shallow: true }).then(() => {
      router.reload();
    });
  };

  return (
    <div className="h-full">
      <div
        className="w-full py-2 px-4 bg-olaf-green-500 flex justify-between items-center rounded-tl-lg rounded-br-lg lg:hidden"
        onClick={() => (isOpen ? setIsOpen(false) : setIsOpen(true))}
      >
        <span className="text-white font-bold">Filter</span>
        <img src="/assets/icon/chevron-down.svg" alt="Chevron down" />
      </div>
      <div
        className={`z-[60] lg:z-[40] fixed lg:relative bottom-0 left-0 w-full h-[calc(100%_-_49px_-_10px)] bg-white transform lg:h-auto lg:translate-y-0 lg:px-2 ${
          isOpen ? "translate-y-none" : "translate-y-full"
        } transition duration-300 ease-in-out`}
      >
        <div className="olafGrid pt-8 pb-12 h-full flex flex-col">
          <div className="flex items-center justify-between">
            <h2>Filters</h2>
            <div
              onClick={() => (isOpen ? setIsOpen(false) : setIsOpen(true))}
              className="lg:hidden"
            >
              <img src="/assets/icon/close.svg" alt="Close button" />
            </div>
          </div>
          <form
            id="filter"
            className="grow flex flex-col mt-4 overflow-y-auto"
            onSubmit={handlefilter}
          >
            <div className="flex space-x-2 mb-4">
              <div
                className="cursor-pointer w-full h-[40px] flex items-center justify-center rounded-tl-[10px] rounded-br-[10px] text-sm font-bold border-2 bg-transparent text-olaf-green-500 border-olaf-green-500 hover:bg-olaf-green-500 hover:text-white transition duration-200 ease-in-out"
                onClick={() => setReset(true)}
              >
                Filters wissen
              </div>
              <InputButton text="Toepassen" style="primary" />
            </div>
            {children}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Filter;
